export const VH_SPECIAL_AUDIO_UNLOCKS_ENABLED =
  String(process.env.REACT_APP_VH_SPECIAL_AUDIO_UNLOCKS_ENABLED || "0") === "1";

export const PROLOGUE_AUTO_UNLOCK = true;
export const FIRST_PROGRESSIVE_UNLOCK_AT = 50;
export const NEXT_UNLOCK_EVERY = 50;
export const SPECIAL_AUDIOBOOK_RELEVANT_EVENT_ENABLED = true;
export const SPECIAL_AUDIOBOOK_RELEVANT_EVENT_COOLDOWN_TURNS = 8;
export const SPECIAL_AUDIOBOOK_RELEVANT_MIN_MESSAGE_LENGTH = 20;
export const SPECIAL_AUDIO_SCHEMA_VERSION = 1;
export const SPECIAL_AUDIO_STORAGE_PREFIX = `vh:special-audio:v${SPECIAL_AUDIO_SCHEMA_VERSION}:`;
export const PROLOGUE_AUDIO_ID = "PROLOGUE";

export const VH_AUDIO_UNLOCK_PHRASES = [
  "Acredito que voce ja esteja pronto para ouvir...",
  "O passado comeca a falar... quando voce para de ignorar os sinais.",
  "Voce esta comecando a enxergar... poucos chegam ate aqui.",
  "Nem tudo pode ser explicado... algumas coisas precisam ser sentidas.",
  "Agora voce comeca a entender... por que eu voltei.",
  "O que voce esta vendo... ja esteve aqui antes.",
  "A verdade nao e confortavel... mas e inevitavel.",
  "A maioria para aqui... nao porque nao pode continuar... mas porque nao quer.",
  "Se chegou ate aqui... ja nao e mais o mesmo.",
  "Agora voce entende... o que esta em jogo.",
  "A partir daqui... nao ha mais retorno.",
];

export const SPECIAL_AUDIO_ORDER = [
  "ID_01",
  "ID_02",
  "P1",
  "P2",
  "P3",
  "P4",
  "P5",
  "E1",
  "E2",
  "E3",
  "V1",
  "V2",
  "V3",
  "V4",
  "F1",
];

const SPECIAL_AUDIOBOOK_RELEVANT_PROBLEM_PATTERNS = [
  /\bnao consigo\b/,
  /\bestou com problema\b/,
  /\bestou com dificuldade\b/,
  /\btenho dificuldade\b/,
  /\bnao sei lidar com\b/,
  /\bestou travad[oa]\b/,
  /\bisso esta acontecendo comigo\b/,
  /\bestou pensando em desistir\b/,
  /\bcomo lidar com\b/,
  /\bcomo faco para sair disso\b/,
  /\bi can't\b/,
  /\bi cannot\b/,
  /\bi'm stuck\b/,
  /\bi am stuck\b/,
  /\bi have a problem\b/,
  /\bi'm having trouble\b/,
  /\bi am having trouble\b/,
  /\bthis is happening to me\b/,
  /\bno puedo\b/,
  /\bestoy con un problema\b/,
  /\btengo un problema\b/,
  /\btengo dificultad\b/,
  /\bno se lidiar con\b/,
  /\bestoy trabad[oa]\b/,
  /\besto me esta pasando\b/,
  /\bestoy pensando en rendirme\b/,
  /\bcomo lidiar con\b/,
];

const SPECIAL_AUDIOBOOK_RELEVANT_DECISION_PATTERNS = [
  /\bdevo\b/,
  /\bnao sei se\b/,
  /\bvale a pena\b/,
  /\bestou em duvida\b/,
  /\bqual caminho\b/,
  /\bqual decisao\b/,
  /\bdevo escolher\b/,
  /\bshould i\b/,
  /\bi don't know if\b/,
  /\bi do not know if\b/,
  /\bis it worth it\b/,
  /\bi'm torn between\b/,
  /\bi am torn between\b/,
  /\bwhich path\b/,
  /\bdebo\b/,
  /\bno se si\b/,
  /\bvale la pena\b/,
  /\bestoy en duda\b/,
  /\bque camino\b/,
  /\bque decision\b/,
];

const SPECIAL_AUDIOBOOK_RELEVANT_CONTINUITY_PATTERNS = [
  /\bcontinuando\b/,
  /\bvoltando ao assunto\b/,
  /\bsobre aquilo\b/,
  /\besse problema\b/,
  /\bcontinuing\b/,
  /\bgoing back to that\b/,
  /\babout that\b/,
  /\bthat problem\b/,
  /\bcontinuando con\b/,
  /\bvolviendo al tema\b/,
  /\bsobre aquello\b/,
  /\bese problema\b/,
];

const SPECIAL_AUDIOBOOK_NON_RELEVANT_SHORT_PATTERNS = [
  /^(ok|okay|valeu|obrigad[oa]|thanks|thank you|gracias|sim|nao|yes|no)[!.?\s]*$/,
  /^(bom dia|boa tarde|boa noite|hi|hello|hola)[!.?\s]*$/,
];

export const SPECIAL_AUDIO_CATALOG = {
  [PROLOGUE_AUDIO_ID]: {
    audio_id: PROLOGUE_AUDIO_ID,
    title: "Prologue: The Wraith of Heavens",
    files: {
      en: "/audiobooks/en/trilhas especiais ingles/audiobook prologue van helsin the wraith of heavens.mp3",
      es: "/audiobooks/es/trilhas especiais espanhol/audiobook espanhol prologo van helsin la ira dos celus 1.mp3",
      pt: "/audiobooks/pt/trilhas especiais portugues/audiobook prologo van helsin a ira dos ceus.mp3",
    },
  },
  ID_01: {
    audio_id: "ID_01",
    title: "The Inheritance of Silence",
    files: {
      en: "/audiobooks/en/chapter 1 - The Inheritance of Silence.mp3",
      es: "/audiobooks/es/capitulo 1 - La Herencia Maldita.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 1.mp3",
    },
  },
  ID_02: {
    audio_id: "ID_02",
    title: "The Awakening of the Hunter",
    files: {
      en: "/audiobooks/en/chapter 2 - The Awakening of the Hunter.mp3",
      es: "/audiobooks/es/capitulo 2 - El Nacimiento de un Cazador.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 2.mp3",
    },
  },
  P1: {
    audio_id: "P1",
    title: "The First Pillar: The Market Is Not Your Friend",
    files: {
      en: "/audiobooks/en/chapter 3 - The First Pillar the market its not your friend.mp3",
      es: "/audiobooks/es/Capitulo 3 - El Primer Pilar El Mercado No Es Tu Amigo.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 3.mp3",
    },
  },
  P2: {
    audio_id: "P2",
    title: "The Second Pillar",
    files: {
      en: "/audiobooks/en/chapter 4 - The second Pillar.mp3",
      es: "/audiobooks/es/capitulo 4 - el segundo pilar.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 4.mp3",
    },
  },
  P3: {
    audio_id: "P3",
    title: "The Third Pillar",
    files: {
      en: "/audiobooks/en/chapter 5 - The third Pillar.mp3",
      es: "/audiobooks/es/capitulo 5 - el tercer pilar.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 5.mp3",
    },
  },
  P4: {
    audio_id: "P4",
    title: "The Fourth Pillar",
    files: {
      en: "/audiobooks/en/chapter 6 - The fourth Pillar.mp3",
      es: "/audiobooks/es/capitulo 6 - el cuarto pilar.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 6.mp3",
    },
  },
  P5: {
    audio_id: "P5",
    title: "The Fifth Pillar",
    files: {
      en: "/audiobooks/en/chapter 7 - The fifth Pillar.mp3",
      es: "/audiobooks/es/capitulo 7 - el quinto pilar.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 7.mp3",
    },
  },
  E1: {
    audio_id: "E1",
    title: "Dance with the Vampires",
    files: {
      en: "/audiobooks/en/chapter 8 - Dance with the vampires.mp3",
      es: "/audiobooks/es/capitulo 8 - la danza de los vampiros.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 8.mp3",
    },
  },
  E2: {
    audio_id: "E2",
    title: "Lady Inflation",
    files: {
      en: "/audiobooks/en/chapter 9 - Lady inflation.mp3",
      es: "/audiobooks/es/capitulo 9 - lady inflacion.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 9.mp3",
    },
  },
  E3: {
    audio_id: "E3",
    title: "Shadow from the Past",
    files: {
      en: "/audiobooks/en/chapter 10 - Shadow from the past.mp3",
      es: "/audiobooks/es/capitulo 10 - la casa de la perdicion.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 10.mp3",
    },
  },
  V1: {
    audio_id: "V1",
    title: "The Kiss of the Past",
    files: {
      en: "/audiobooks/en/chapter 11 - The Kiss of the Past.mp3",
      es: "/audiobooks/es/capitulo 11 - el beso del pasado.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 11.mp3",
    },
  },
  V2: {
    audio_id: "V2",
    title: "The Kidnapping of Rachel",
    files: {
      en: "/audiobooks/en/chapter 12 - The Kidnapping of Rachel.mp3",
      es: "/audiobooks/es/capitulo 12 - el secuestro de rachel.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 12.mp3",
    },
  },
  V3: {
    audio_id: "V3",
    title: "The Impossible Rescue",
    files: {
      en: "/audiobooks/en/chapter 13 - The Impossible Rescue in the league of shadows.mp3",
      es: "/audiobooks/es/capitulo 13 - El Rescate Imposible en la Liga de las Sombras.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 13.mp3",
    },
  },
  V4: {
    audio_id: "V4",
    title: "True Love Never Dies... But What If It Never Lived",
    files: {
      en: "/audiobooks/en/chapter 14 - True Love Never Dies... But What If It Never Lived.mp3",
      es: "/audiobooks/es/capitulo 14 - El Verdadero Amor Nunca Muere... Pero ¿Y Si Nunca Existió.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 14.mp3",
    },
  },
  F1: {
    audio_id: "F1",
    title: "The Final Showdown",
    files: {
      en: "/audiobooks/en/chapter 15 - The Final Showdown Van helsin Falls in to the trap.mp3",
      es: "/audiobooks/es/trilhas especiais espanhol/capitulo 15 - El enfrentamiento final Van Helsin cae en la trampa.mp3",
      pt: "/audiobooks/pt/audiobook completo/capitulo 15.mp3",
    },
  },
};

function getDefaultStorage(storage) {
  if (storage) return storage;
  if (typeof window === "undefined") return null;
  return window.localStorage || null;
}

function uniqueIds(items) {
  const src = Array.isArray(items) ? items : [];
  const out = [];
  const seen = new Set();
  src.forEach((item) => {
    const id = String(item || "").trim();
    if (!id || seen.has(id) || !SPECIAL_AUDIO_CATALOG[id]) return;
    seen.add(id);
    out.push(id);
  });
  return out;
}

function addUniqueId(items, id) {
  const list = uniqueIds(items);
  const key = String(id || "").trim();
  if (!key || list.includes(key) || !SPECIAL_AUDIO_CATALOG[key]) return list;
  return [...list, key];
}

function removeId(items, id) {
  const key = String(id || "").trim();
  return uniqueIds(items).filter((item) => item !== key);
}

function sanitizeCounter(value) {
  const n = Number(value || 0);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.floor(n));
}

function sanitizeOfferReason(value) {
  const reason = String(value || "").trim().toLowerCase();
  if (reason === "relevant_event" || reason === "fallback") {
    return reason;
  }
  return null;
}

function normalizeRelevantText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

function getRecentContextSnippet(recentContext) {
  if (!Array.isArray(recentContext) || !recentContext.length) return "";
  return recentContext
    .slice(-4)
    .map((item) => {
      if (typeof item === "string") return item;
      if (!item || typeof item !== "object") return "";
      return String(item.text || item.content || "").trim();
    })
    .filter(Boolean)
    .join(" ")
    .trim();
}

function matchesAnyPattern(text, patterns) {
  return patterns.some((pattern) => pattern.test(text));
}

export function createDefaultSpecialAudioState() {
  return {
    version: SPECIAL_AUDIO_SCHEMA_VERSION,
    interaction_count: 0,
    phrase_index: 0,
    unlocked_ids: [],
    prologue_unlocked: false,
    pending_local_offer_ids: [],
    phrase_shown_offer_ids: [],
    last_offer_turn: 0,
    last_offer_reason: null,
    relevant_event_cooldown_until_turn: 0,
  };
}

export function sanitizeSpecialAudioState(raw) {
  const base = createDefaultSpecialAudioState();
  const unlockedIds = uniqueIds(raw?.unlocked_ids);
  const prologueUnlocked =
    raw?.prologue_unlocked === true || unlockedIds.includes(PROLOGUE_AUDIO_ID);
  const nextUnlocked = prologueUnlocked
    ? addUniqueId(unlockedIds, PROLOGUE_AUDIO_ID)
    : unlockedIds;
  const pendingIds = uniqueIds(raw?.pending_local_offer_ids).filter((id) =>
    nextUnlocked.includes(id)
  );
  const phraseShownIds = uniqueIds(raw?.phrase_shown_offer_ids).filter((id) =>
    nextUnlocked.includes(id)
  );
  return {
    ...base,
    version: SPECIAL_AUDIO_SCHEMA_VERSION,
    interaction_count: sanitizeCounter(raw?.interaction_count),
    phrase_index: sanitizeCounter(raw?.phrase_index),
    unlocked_ids: nextUnlocked,
    prologue_unlocked: prologueUnlocked,
    pending_local_offer_ids: pendingIds,
    phrase_shown_offer_ids: phraseShownIds,
    last_offer_turn: sanitizeCounter(raw?.last_offer_turn),
    last_offer_reason: sanitizeOfferReason(raw?.last_offer_reason),
    relevant_event_cooldown_until_turn: sanitizeCounter(
      raw?.relevant_event_cooldown_until_turn
    ),
  };
}

export function getSpecialAudioStorageKey(uid) {
  const key = String(uid || "").trim();
  return key ? `${SPECIAL_AUDIO_STORAGE_PREFIX}${key}` : "";
}

export function repairLoadedSpecialAudioState(state) {
  const safeState = sanitizeSpecialAudioState(state);
  if (
    !safeState.pending_local_offer_ids.includes(PROLOGUE_AUDIO_ID) ||
    !safeState.phrase_shown_offer_ids.includes(PROLOGUE_AUDIO_ID)
  ) {
    return safeState;
  }
  return sanitizeSpecialAudioState({
    ...safeState,
    phrase_shown_offer_ids: safeState.phrase_shown_offer_ids.filter(
      (id) => id !== PROLOGUE_AUDIO_ID
    ),
  });
}

export function loadSpecialAudioState(uid, storage) {
  const store = getDefaultStorage(storage);
  const key = getSpecialAudioStorageKey(uid);
  const fallback = createDefaultSpecialAudioState();
  if (!store || !key) return fallback;
  try {
    const raw = store.getItem(key);
    if (!raw) return fallback;
    return repairLoadedSpecialAudioState(JSON.parse(raw));
  } catch {
    try {
      store.removeItem(key);
    } catch {}
    return fallback;
  }
}

export function persistSpecialAudioState(uid, state, storage) {
  const store = getDefaultStorage(storage);
  const key = getSpecialAudioStorageKey(uid);
  const nextState = sanitizeSpecialAudioState(state);
  if (!store || !key) return nextState;
  try {
    store.setItem(key, JSON.stringify(nextState));
  } catch {}
  return nextState;
}

export function clearSpecialAudioState(uid, storage) {
  const store = getDefaultStorage(storage);
  const key = getSpecialAudioStorageKey(uid);
  if (!store || !key) return;
  try {
    store.removeItem(key);
  } catch {}
}

export function getProgressiveThresholdForIndex(index) {
  const n = sanitizeCounter(index);
  return FIRST_PROGRESSIVE_UNLOCK_AT + NEXT_UNLOCK_EVERY * n;
}

export function getNextUnlockPhrase(index) {
  const safe = sanitizeCounter(index);
  return VH_AUDIO_UNLOCK_PHRASES[Math.min(safe, VH_AUDIO_UNLOCK_PHRASES.length - 1)] || "";
}

export function getSpecialAudioOffer(audioId) {
  const key = String(audioId || "").trim();
  const entry = SPECIAL_AUDIO_CATALOG[key];
  if (!entry) return null;
  return {
    source: "local",
    offer_key: `local:${key}`,
    local_offer_id: key,
    offer_id: "",
    audio_id: entry.audio_id,
    title: entry.title,
    available_langs: ["en", "es", "pt"],
    audio_files: { ...(entry.files || {}) },
  };
}

export function getPendingSpecialAudioOffers(state) {
  const safeState = sanitizeSpecialAudioState(state);
  return safeState.pending_local_offer_ids
    .map((id) => getSpecialAudioOffer(id))
    .filter(Boolean);
}

export function unlockSpecialAudio(state, audioId) {
  const key = String(audioId || "").trim();
  if (!SPECIAL_AUDIO_CATALOG[key]) {
    return sanitizeSpecialAudioState(state);
  }
  const safeState = sanitizeSpecialAudioState(state);
  return sanitizeSpecialAudioState({
    ...safeState,
    unlocked_ids: addUniqueId(safeState.unlocked_ids, key),
    pending_local_offer_ids: addUniqueId(safeState.pending_local_offer_ids, key),
    prologue_unlocked: safeState.prologue_unlocked || key === PROLOGUE_AUDIO_ID,
  });
}

export function ensureAutoPrologueUnlocked(state) {
  const safeState = sanitizeSpecialAudioState(state);
  if (!PROLOGUE_AUTO_UNLOCK || safeState.prologue_unlocked) {
    return { state: safeState, unlockedId: "" };
  }
  return {
    state: unlockSpecialAudio(safeState, PROLOGUE_AUDIO_ID),
    unlockedId: PROLOGUE_AUDIO_ID,
  };
}

export function ensurePrologueOfferPending(state) {
  const safeState = sanitizeSpecialAudioState(state);
  if (!PROLOGUE_AUTO_UNLOCK || !safeState.prologue_unlocked) return safeState;
  if (safeState.pending_local_offer_ids.includes(PROLOGUE_AUDIO_ID)) return safeState;
  // User dismissed or accepted — do not resurface.
  if (safeState.phrase_shown_offer_ids.includes(PROLOGUE_AUDIO_ID)) return safeState;
  return unlockSpecialAudio(safeState, PROLOGUE_AUDIO_ID);
}

export function getPendingPrologueOffer(state) {
  if (!PROLOGUE_AUTO_UNLOCK) return null;
  const safeState = sanitizeSpecialAudioState(state);
  if (!safeState.pending_local_offer_ids.includes(PROLOGUE_AUDIO_ID)) {
    return null;
  }
  return getSpecialAudioOffer(PROLOGUE_AUDIO_ID);
}

export function getNextEligibleSpecialAudioId(state) {
  const safeState = sanitizeSpecialAudioState(state);
  const unlockedSet = new Set(safeState.unlocked_ids);
  for (let i = 0; i < SPECIAL_AUDIO_ORDER.length; i += 1) {
    const id = SPECIAL_AUDIO_ORDER[i];
    if (unlockedSet.has(id)) continue;
    if (safeState.interaction_count >= getProgressiveThresholdForIndex(i)) {
      return id;
    }
  }
  return "";
}

export function getNextLockedSpecialAudioId(state) {
  const safeState = sanitizeSpecialAudioState(state);
  const unlockedSet = new Set(safeState.unlocked_ids);
  for (let i = 0; i < SPECIAL_AUDIO_ORDER.length; i += 1) {
    const id = SPECIAL_AUDIO_ORDER[i];
    if (!unlockedSet.has(id)) {
      return id;
    }
  }
  return "";
}

export function isRelevantConversationEvent(message, recentContext) {
  if (!SPECIAL_AUDIOBOOK_RELEVANT_EVENT_ENABLED) return false;
  const text = normalizeRelevantText(message);
  if (!text) return false;
  if (matchesAnyPattern(text, SPECIAL_AUDIOBOOK_NON_RELEVANT_SHORT_PATTERNS)) {
    return false;
  }

  const problemMatch = matchesAnyPattern(
    text,
    SPECIAL_AUDIOBOOK_RELEVANT_PROBLEM_PATTERNS
  );
  const decisionMatch = matchesAnyPattern(
    text,
    SPECIAL_AUDIOBOOK_RELEVANT_DECISION_PATTERNS
  );
  if (problemMatch || decisionMatch) {
    return true;
  }

  const wordCount = text.split(" ").filter(Boolean).length;
  if (
    text.length < SPECIAL_AUDIOBOOK_RELEVANT_MIN_MESSAGE_LENGTH ||
    wordCount < 4
  ) {
    return false;
  }

  const recentText = normalizeRelevantText(getRecentContextSnippet(recentContext));
  if (!recentText) return false;
  return matchesAnyPattern(text, SPECIAL_AUDIOBOOK_RELEVANT_CONTINUITY_PATTERNS);
}

export function registerSuccessfulNormalTurn(state, options = {}) {
  const safeState = sanitizeSpecialAudioState(state);
  const nextState = sanitizeSpecialAudioState({
    ...safeState,
    interaction_count: safeState.interaction_count + 1,
  });
  const hasBackendOffer = options?.hasBackendOffer === true;
  const nextTurn = nextState.interaction_count;
  const relevantEvent = isRelevantConversationEvent(
    options?.message,
    options?.recentContext
  );
  const nextLockedId = getNextLockedSpecialAudioId(nextState);
  const fallbackUnlockedId = getNextEligibleSpecialAudioId(nextState);
  const fallbackDue = Boolean(fallbackUnlockedId);
  const cooldownUntil = sanitizeCounter(
    safeState.relevant_event_cooldown_until_turn
  );
  const cooldownOk = nextTurn > cooldownUntil;

  if (hasBackendOffer) {
    return { state: nextState, unlockedId: "" };
  }

  if (relevantEvent && cooldownOk && nextLockedId) {
    const unlockedState = unlockSpecialAudio(nextState, nextLockedId);
    return {
      state: sanitizeSpecialAudioState({
        ...unlockedState,
        last_offer_turn: nextTurn,
        last_offer_reason: "relevant_event",
        relevant_event_cooldown_until_turn:
          nextTurn + SPECIAL_AUDIOBOOK_RELEVANT_EVENT_COOLDOWN_TURNS,
      }),
      unlockedId: nextLockedId,
      reason: "relevant_event",
      relevantEvent,
      cooldownOk,
      fallbackDue,
      localSkipped: false,
    };
  }

  if (!fallbackUnlockedId) {
    return {
      state: nextState,
      unlockedId: "",
      reason: relevantEvent && !cooldownOk ? "cooldown_block" : null,
      relevantEvent,
      cooldownOk,
      fallbackDue,
      localSkipped: false,
    };
  }

  return {
    state: sanitizeSpecialAudioState({
      ...unlockSpecialAudio(nextState, fallbackUnlockedId),
      last_offer_turn: nextTurn,
      last_offer_reason: "fallback",
    }),
    unlockedId: fallbackUnlockedId,
    reason: "fallback",
    relevantEvent,
    cooldownOk,
    fallbackDue,
    localSkipped: false,
  };
}

export function clearPendingSpecialAudioOffer(state, audioId) {
  const key = String(audioId || "").trim();
  const safeState = sanitizeSpecialAudioState(state);
  return sanitizeSpecialAudioState({
    ...safeState,
    pending_local_offer_ids: removeId(safeState.pending_local_offer_ids, key),
  });
}

export function markSpecialAudioPhraseShown(state, audioId) {
  const key = String(audioId || "").trim();
  const safeState = sanitizeSpecialAudioState(state);
  if (!key || safeState.phrase_shown_offer_ids.includes(key)) {
    return { state: safeState, phrase: "" };
  }
  const phrase = getNextUnlockPhrase(safeState.phrase_index);
  const nextState = sanitizeSpecialAudioState({
    ...safeState,
    phrase_index: safeState.phrase_index + 1,
    phrase_shown_offer_ids: addUniqueId(safeState.phrase_shown_offer_ids, key),
  });
  return { state: nextState, phrase };
}

export function isLocalSpecialAudiobookOffer(offer) {
  return String(offer?.source || "").trim().toLowerCase() === "local";
}

export function resolveLocalAudiobookSource(offer, lang) {
  const files = offer?.audio_files && typeof offer.audio_files === "object" ? offer.audio_files : {};
  const requested = String(lang || "").trim().toLowerCase();
  const raw =
    String(files[requested] || files.pt || files.en || files.es || "").trim();
  return raw ? encodeURI(raw) : "";
}

export function insertAudiobookOfferInQueue(queue, offer) {
  const list = Array.isArray(queue) ? queue.filter(Boolean) : [];
  const nextOffer = offer && typeof offer === "object" ? offer : null;
  const offerKey = String(nextOffer?.offer_key || "").trim();
  if (!nextOffer || !offerKey) return list;
  if (list.some((item) => String(item?.offer_key || "").trim() === offerKey)) {
    return list;
  }
  if (isLocalSpecialAudiobookOffer(nextOffer)) {
    return [...list, nextOffer];
  }
  const firstLocalIndex = list.findIndex((item) => isLocalSpecialAudiobookOffer(item));
  if (firstLocalIndex < 0) return [...list, nextOffer];
  return [
    ...list.slice(0, firstLocalIndex),
    nextOffer,
    ...list.slice(firstLocalIndex),
  ];
}

export function pullNextQueuedAudiobookOffer(queue, options = {}) {
  const list = Array.isArray(queue) ? queue.filter(Boolean) : [];
  const allowLocal = options?.allowLocal !== false;
  if (!list.length) {
    return { offer: null, queue: [] };
  }
  const idx = list.findIndex((item) => {
    if (!isLocalSpecialAudiobookOffer(item)) return true;
    return allowLocal;
  });
  if (idx < 0) {
    return { offer: null, queue: list };
  }
  return {
    offer: list[idx],
    queue: [...list.slice(0, idx), ...list.slice(idx + 1)],
  };
}

export function emitSpecialAudioTelemetry(eventName, payload = {}) {
  const event = String(eventName || "").trim();
  if (!event) return;
  const detail = {
    event,
    ts: Date.now(),
    ...payload,
  };
  try {
    console.info(`[VH-AUDIO-TELEMETRY] ${event}`, JSON.stringify(detail));
  } catch {}
  try {
    if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...payload });
    }
  } catch {}
  try {
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
      window.dispatchEvent(new CustomEvent("vh-audio-telemetry", { detail }));
    }
  } catch {}
}
